import router from "@/router";
import { RouteNames } from "@/types/ui";
import { createOverlay } from "@/utils/overlay";
import { nextTick, ref } from "vue";

// Helper variable used when scroll is called before API data is received
export const pendingScrollTarget = ref<string | null>(null);

export const executeScroll = (el: HTMLElement): void => {
	el.scrollIntoView({ behavior: "smooth", block: "center" });

	setTimeout((): void => {
		if (!el) return;
		const children = Array.from(el.children) as Array<HTMLElement>;

		if (children.length > 0) {
			children.forEach((child: HTMLElement, index: number): void =>
				createOverlay(child as HTMLElement, index),
			);
		} else {
			createOverlay(el, 0);
		}
	}, 1000);
};

export const scrollToRef = async (scrollTo: string): Promise<void> => {
	await nextTick();

	const el = document.querySelector(
		`[data-section-key="${scrollTo}"]`,
	) as HTMLElement;

	if (!el) {
		// Element missing, saving to shared state
		pendingScrollTarget.value = scrollTo;
		return;
	}

	executeScroll(el);

	// Remove scrollTo to allow re-triggering the scroll functionality on subsequent shop actions
	router.replace({
		name: RouteNames.SHOP,
		params: Object.fromEntries(
			Object.entries(router.currentRoute.value.params).filter(
				([key]: [string, string | Array<string>]): boolean =>
					key !== "scrollTo",
			),
		),
	});
};
